var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 386,
    viewBox: "0 0 238 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.257 155.376C234.257 71.6429 164.686 3.65784 79 3.65783C-6.68594 3.65783 -76.2568 71.6429 -76.2568 155.376L-76.2568 411.342L234.257 411.342L234.257 155.376ZM79 -5.0753e-06C166.753 -2.2742e-06 238 69.6228 238 155.376L238 415L-80 415L-80 155.376C-80 69.6228 -8.75323 -7.87639e-06 79 -5.0753e-06Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.562 237.266C137.562 179.814 89.8228 133.164 31.0314 133.164C-27.7599 133.164 -75.4988 179.814 -75.4988 237.266L-75.4988 411.333L137.562 411.333L137.562 237.266ZM31.0314 129.506C91.8901 129.506 141.305 177.794 141.305 237.266L141.305 414.991L-79.242 414.991L-79.242 237.266C-79.242 177.794 -29.8272 129.506 31.0314 129.506Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8057 309.975C58.2005 274.267 28.3471 245.459 -8.3372 245.459C-45.3996 245.459 -75.4895 274.863 -75.4895 311.081L-75.4895 411.333L58.8057 411.333L58.8057 309.975ZM62.5488 312.91L62.5582 312.91L62.5582 311.081C62.5582 272.843 30.7924 241.801 -8.3372 241.801C-47.4668 241.801 -79.2326 272.843 -79.2326 311.081L-79.2326 414.991L62.5488 414.991L62.5488 312.91Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLines);
export default __webpack_public_path__ + "static/media/logo-lines.73fbf32c52a9a1613a6789f68da6a322.svg";
export { ForwardRef as ReactComponent };